import React, { useEffect, useRef, useState } from "react";
import {
  Container,
  Col,
  Form,
  Row,
  Spinner,
  Table,
  Button,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import html2pdf from "html2pdf.js";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import pdf from "html-pdf";
import {
  getBase64Document,
  getPDFDocument,
} from "../../redux/descriptorsProfiles/GeneralInfo/actions";

const DocumentoDescriptorPDFComponent = (props) => {
  const [headerText, setHeaderText] = useState("");

  const pdfDocRef = useRef();
  const dispatch = useDispatch();

  const { loading, overviews } = useSelector((store) => store.overview);
  const { loadingPdfDocument, pdfDescriptor } = useSelector(
    (store) => store.generalInfo
  );

  // Métodos
  useEffect(() => {
    if (props.id) {
      let req = {};
      if (props.id_colab) {
        req.md = parseInt(props.id_colab);
      }
      if (!req.md) {
        dispatch(getBase64Document(parseInt(props.id)));
      }
      dispatch(getPDFDocument(parseInt(props.id), req));
    }
  }, [props.id, props.id_colab]);

  // const GenerarPdf = async () => {
  //   props.setLoadingPrint(true);

  //   const pdfElement = pdfDocRef.current;

  //   try {
  //     await html2pdf(pdfElement, {
  //       margin: [15, 10],
  //       filename: `${props.nombre}.pdf`,
  //       image: { type: "jpeg", quality: 1 },
  //       html2canvas: { scale: 2, logging: true, useCORS: true },
  //       jsPDF: {
  //         unit: "mm",
  //         format: "a4",
  //         orientation: "portrait",
  //         hotfixes: ["px_scaling"],
  //       },
  //       pagebreak: { mode: "avoid-all" },
  //     });
  //   } catch (error) {
  //     console.error("Error generando PDF:", error);
  //   } finally {
  //     props.setLoadingPrint(false);
  //   }
  // };

  const GenerarPdf = () => {
    const element = pdfDocRef.current;

    var opt = {
      margin: 0.8,
      filename: `${props.nombre}.pdf`,
      enableLinks: false,
      pagebreak: { mode: "avoid-all" },
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
    };

    html2pdf()
      .from(element)
      .set(opt)
      .toPdf()
      .get("pdf")
      .then(function (pdf) {
        var totalPages = pdf.internal.getNumberOfPages();

        for (var i = 1; i <= totalPages; i++) {
          pdf.setPage(i);
          pdf.setFontSize(10);
          pdf.setTextColor(150);

          // Add page number at the bottom center
          pdf.text(
            "F-651V3",
            pdf.internal.pageSize.getWidth() / 2 + 2.6,
            pdf.internal.pageSize.getHeight() - 11
          );
        }
      })
      .save();
  };

  return (
    <>
      <OverlayTrigger
        placement="auto"
        overlay={<Tooltip {...props}>Descargar descriptor</Tooltip>}
      >
        <Button
          className="rounded-pill"
          variant="link"
          type="button"
          onClick={GenerarPdf}
          disabled={loadingPdfDocument}
        >
          {props.id_colab ? (
            <i className="material-icons">file_download</i>
          ) : (
            "aquí"
          )}
        </Button>
      </OverlayTrigger>
      <div
        style={{
          position: "absolute",
          top: "-99999999999px",
        }}
      >
        <Container fluid>
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : (
            <>
              <div ref={pdfDocRef}>
                <div>
                  <div>
                    <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 py-2 text-muted d-flex flex-wrap justify-content-between align-items-center">
                      <Col md="12">
                        <Row className="justify-content-sm-end align-items-center flex-nowrap">
                          <Col className="px-0 py-1">
                            <h6 className="font-weight-bold text-uppercase">
                              DESCRIPTOR y PERFIL DE PUESTOS
                            </h6>
                          </Col>
                        </Row>
                      </Col>
                    </div>
                    <Col md="12" className="mt-3">
                      <Table striped bordered hover>
                        <thead>
                          <tr>
                            <th className="text-muted">
                              <b>Dato</b>
                            </th>
                            <th className="text-muted">
                              <b>Informacion</b>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Empresa:</td>
                            <td>
                              {pdfDescriptor ? pdfDescriptor.empresa : ""}
                            </td>
                          </tr>
                          <tr>
                            <td>Nombre de la posición:</td>
                            <td>
                              {pdfDescriptor
                                ? pdfDescriptor.Nombre_de_la_posición
                                : ""}
                            </td>
                          </tr>
                          <tr>
                            <td>Unidad Organizativa:</td>
                            <td>
                              {pdfDescriptor
                                ? pdfDescriptor.Unidad_Organizativa
                                : ""}
                            </td>
                          </tr>
                          <tr>
                            <td>Numero de Ocupantes:</td>
                            <td>
                              {pdfDescriptor
                                ? pdfDescriptor.Numero_de_Ocupantes
                                : ""}
                            </td>
                          </tr>
                          <tr>
                            <td>Numero de Ocupantes:</td>
                            <td>
                              {pdfDescriptor
                                ? pdfDescriptor.Numero_de_Ocupantes
                                : ""}
                            </td>
                          </tr>
                          <tr>
                            <td>Número de Personas que supervisa:</td>
                            <td>
                              {pdfDescriptor
                                ? pdfDescriptor.Número_de_Personas_que_supervisa
                                : ""}
                            </td>
                          </tr>
                          <tr>
                            <td>Posición que Puede Cubrir las funciones:</td>
                            <td>
                              {pdfDescriptor
                                ? pdfDescriptor.Posición_que_Puede_Cubrir_las_funciones
                                : ""}
                            </td>
                          </tr>
                          <tr>
                            <td>Clasificación:</td>
                            <td>
                              {pdfDescriptor ? pdfDescriptor.Clasificación : "bcbcbc"}
                            </td>
                          </tr>
                          <tr>
                            <td>Fecha Elaboracion:</td>
                            <td>
                              {pdfDescriptor && pdfDescriptor.fecha_creacion
                                ? // moment(
                                  pdfDescriptor.fecha_creacion
                                : // ).format("DD/MM/YYYY")
                                  ""}
                            </td>
                          </tr>
                          <tr>
                            <td>Fecha Actualización</td>
                            <td>
                              {pdfDescriptor &&
                              pdfDescriptor.fecha_actualizacion_descriptor
                                ? // moment(
                                  pdfDescriptor.fecha_actualizacion_descriptor
                                : // ).format("DD/MM/YYYY")
                                  ""}
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </Col>
                    <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 py-2 text-muted d-flex flex-wrap justify-content-between align-items-center">
                      <Col md="12">
                        <Row className="justify-content-sm-end align-items-center flex-nowrap">
                          <Col className="px-0 py-1">
                            <h6 className="font-weight-bold text-uppercase">
                              Proposito general del puesto
                            </h6>
                          </Col>
                        </Row>
                      </Col>
                    </div>
                    <Col md="12" className="mt-3">
                      <div
                        className="px-2 py-1 rounded border border-muted"
                        style={{
                          // backgroundColor: "#F4F4F4",
                          minHeight: "100px",
                        }}
                      >
                        {pdfDescriptor ? pdfDescriptor.proposito_general : ""}
                      </div>
                    </Col>
                    <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 py-2 text-muted d-flex flex-wrap justify-content-between align-items-center">
                      <Col md="12">
                        <Row className="justify-content-sm-end align-items-center flex-nowrap">
                          <Col className="px-0 py-1">
                            <h6 className="font-weight-bold text-uppercase">
                              Funciones del Puesto
                            </h6>
                          </Col>
                        </Row>
                      </Col>
                    </div>
                    <Col md="12" className="mt-3">
                      <Table striped bordered hover>
                        <thead>
                          <tr>
                            <th className="text-muted">
                              <b>Funciones</b>
                            </th>
                            <th className="text-muted">
                              <b>P</b>
                            </th>
                            <th className="text-muted">
                              <b>CE</b>
                            </th>
                            <th className="text-muted">
                              <b>CM</b>
                            </th>
                            <th className="text-muted">
                              <b>Total</b>
                            </th>
                            <th className="text-muted">
                              <b>Fundamentales</b>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {pdfDescriptor &&
                            pdfDescriptor.Funciones.map((fun) => (
                              <>
                                <tr>
                                  <td>{fun.descripcion}</td>
                                  <td>{fun.perioricidad}</td>
                                  <td>{fun.concecuencias_error}</td>
                                  <td>{fun.complejidad}</td>
                                  <td>
                                    {fun.perioricidad +
                                      fun.complejidad * fun.concecuencias_error}
                                  </td>
                                  <td>{fun.fundamental ? "Si" : "No"}</td>
                                </tr>
                              </>
                            ))}
                        </tbody>
                      </Table>
                    </Col>
                    <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 py-2 text-muted d-flex flex-wrap justify-content-between align-items-center">
                      <Col md="12">
                        <Row className="justify-content-sm-end align-items-center flex-nowrap">
                          <Col className="px-0 py-1">
                            <h6 className="font-weight-bold text-uppercase">
                              Indicadores:
                            </h6>
                          </Col>
                        </Row>
                      </Col>
                    </div>
                    <Col md="12" className="mt-3">
                      <Table striped bordered hover>
                        <thead>
                          <tr>
                            <th className="text-muted">
                              <b>Objetivo</b>
                            </th>
                            <th className="text-muted">
                              <b>Nombre</b>
                            </th>
                            <th className="text-muted">
                              <b>Formula</b>
                            </th>
                            <th className="text-muted">
                              <b>Meta</b>
                            </th>
                            <th className="text-muted">
                              <b>Fuente Verificacion</b>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {pdfDescriptor &&
                            pdfDescriptor.indicadores.map((fun) => (
                              <>
                                <tr>
                                  <td>{fun.indicador__objetivo}</td>
                                  <td>{fun.indicador__nombre}</td>
                                  <td>{fun.indicador__formula_calculo}</td>
                                  <td>{fun.meta}</td>
                                  <td>{fun.fuente_verificacion}</td>
                                </tr>
                              </>
                            ))}
                        </tbody>
                      </Table>
                    </Col>
                    <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 py-2 text-muted d-flex flex-wrap justify-content-between align-items-center">
                      <Col md="12">
                        <Row className="justify-content-sm-end align-items-center flex-nowrap">
                          <Col className="px-0 py-1">
                            <h6 className="font-weight-bold text-uppercase">
                              Matriz de Competencias:
                            </h6>
                          </Col>
                        </Row>
                      </Col>
                    </div>
                    <Col md="12" className="mt-3">
                      <Table striped bordered hover>
                        <thead>
                          <tr>
                            <th className="text-muted">
                              <b>Tipo Competencia</b>
                            </th>
                            <th className="text-muted">
                              <b>Competencia</b>
                            </th>
                            <th className="text-muted">
                              <b>Nivel de Desarrollo</b>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {pdfDescriptor &&
                            pdfDescriptor.competencias.map((fun) => (
                              <>
                                <tr>
                                  <td>{fun.tipo_competencia__descripcion}</td>
                                  <td>{fun.nombre}</td>
                                  <td>{fun.nivel_desarrollo}</td>
                                </tr>
                              </>
                            ))}
                        </tbody>
                      </Table>
                    </Col>
                    <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 py-2 text-muted d-flex flex-wrap justify-content-between align-items-center">
                      <Col md="12">
                        <Row className="justify-content-sm-end align-items-center flex-nowrap">
                          <Col className="px-0 py-1">
                            <h6 className="font-weight-bold text-uppercase">
                              Politicas y Procedimientos:
                            </h6>
                          </Col>
                        </Row>
                      </Col>
                    </div>
                    <Col md="12" className="mt-3">
                      <Table striped bordered hover>
                        <thead>
                          <tr>
                            <th className="text-muted">
                              <b>Politica Y Procedimiento</b>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {pdfDescriptor &&
                            pdfDescriptor.politicas_procedimientos.map(
                              (fun) => (
                                <>
                                  <tr>
                                    <td>{fun.nombre}</td>
                                  </tr>
                                </>
                              )
                            )}
                        </tbody>
                      </Table>
                    </Col>
                    <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 py-2 text-muted d-flex flex-wrap justify-content-between align-items-center">
                      <Col md="12">
                        <Row className="justify-content-sm-end align-items-center flex-nowrap">
                          <Col className="px-0 py-1">
                            <h6 className="font-weight-bold text-uppercase">
                              Informacíon Perfil del Puesto:
                            </h6>
                          </Col>
                        </Row>
                      </Col>
                    </div>
                    <Col md="12" className="mt-3">
                      <Table striped bordered hover>
                        <thead>
                          <tr>
                            <th colSpan="2" className="text-muted">
                              <b>Edad</b>
                            </th>
                            <th colSpan="3" className="text-muted">
                              <b>Género</b>
                            </th>
                            <th colSpan="3" className="text-muted">
                              <b>Viajes de Trabajo</b>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>De</td>
                            <td>A</td>
                            <td>Femenino</td>
                            <td>Masculino</td>
                            <td>Indiferente</td>
                            <td>Si</td>
                            <td>No</td>
                            <td>Ocasionalmente</td>
                          </tr>
                          <tr>
                            <td>
                              {pdfDescriptor
                                ? pdfDescriptor.informacion_del_puesto
                                    .edad_minima
                                : ""}
                            </td>
                            <td>
                              {pdfDescriptor
                                ? pdfDescriptor.informacion_del_puesto
                                    .edad_maxima
                                : ""}
                            </td>
                            <td>
                              {pdfDescriptor
                                ? pdfDescriptor.informacion_del_puesto.genero &&
                                  pdfDescriptor.informacion_del_puesto.genero.toLowerCase() ===
                                    "femenino"
                                  ? "X"
                                  : ""
                                : ""}
                            </td>
                            <td>
                              {pdfDescriptor
                                ? pdfDescriptor.informacion_del_puesto.genero &&
                                  pdfDescriptor.informacion_del_puesto.genero.toLowerCase() ===
                                    "masculino"
                                  ? "X"
                                  : ""
                                : ""}
                            </td>
                            <td>
                              {pdfDescriptor
                                ? pdfDescriptor.informacion_del_puesto.genero &&
                                  pdfDescriptor.informacion_del_puesto.genero.toLowerCase() ===
                                    "indiferente"
                                  ? "X"
                                  : ""
                                : ""}
                            </td>
                            <td>
                              {pdfDescriptor
                                ? pdfDescriptor.informacion_del_puesto
                                    .necesita_viajar &&
                                  pdfDescriptor.informacion_del_puesto.necesita_viajar.toLowerCase() ===
                                    "Si"
                                  ? "X"
                                  : ""
                                : ""}
                            </td>
                            <td>
                              {pdfDescriptor
                                ? pdfDescriptor.informacion_del_puesto
                                    .necesita_viajar &&
                                  pdfDescriptor.informacion_del_puesto.necesita_viajar.toLowerCase() ===
                                    "No"
                                  ? "X"
                                  : ""
                                : ""}
                            </td>
                            <td>
                              {pdfDescriptor
                                ? pdfDescriptor.informacion_del_puesto
                                    .necesita_viajar &&
                                  pdfDescriptor.informacion_del_puesto.necesita_viajar.toLowerCase() ===
                                    "ocasionalmente"
                                  ? "X"
                                  : ""
                                : ""}
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </Col>
                    <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 py-2 text-muted d-flex flex-wrap justify-content-between align-items-center">
                      <Col md="12">
                        <Row className="justify-content-sm-end align-items-center flex-nowrap">
                          <Col className="px-0 py-1">
                            <h6 className="font-weight-bold text-uppercase">
                              Conocimiento y Experiencia:
                            </h6>
                          </Col>
                        </Row>
                      </Col>
                    </div>
                    <Col md="12" className="mt-3">
                      <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 py-2 text-muted d-flex flex-wrap justify-content-between align-items-center">
                        <Col md="12">
                          <Row className="justify-content-sm-end align-items-center flex-nowrap">
                            <Col className="px-0 py-1">
                              <p className="font-weight-bold text-uppercase">
                                a) Conocimiento y Experiencia:
                              </p>
                            </Col>
                          </Row>
                        </Col>
                      </div>
                      <Table striped bordered hover>
                        <thead>
                          <tr>
                            <th className="text-muted">
                              <b>Nivel de Educación Formal</b>
                            </th>
                            <th className="text-muted">
                              <b>Titulos requeridos</b>
                            </th>
                            <th className="text-muted">
                              <b>Areá de conocimientos formales</b>
                            </th>
                            <th className="text-muted">
                              <b>Deseable o indispensable</b>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {pdfDescriptor &&
                            pdfDescriptor.Conocimiento_y_Experiencia.educacion_formal.map(
                              (fun) => (
                                <>
                                  <tr>
                                    <td>
                                      {fun.formacion__nivel_academico__nombre}
                                    </td>
                                    <td>{fun.formacion__titulo}</td>
                                    <td>
                                      {fun.formacion__area_conocimiento__nombre}
                                    </td>
                                    <td>
                                      {fun.indispensable
                                        ? "Deseable"
                                        : "Indispensable"}
                                    </td>
                                  </tr>
                                </>
                              )
                            )}
                        </tbody>
                      </Table>
                    </Col>
                    <Col md="12" className="mt-3">
                      <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 py-2 text-muted d-flex flex-wrap justify-content-between align-items-center">
                        <Col md="12">
                          <Row className="justify-content-sm-end align-items-center flex-nowrap">
                            <Col className="px-0 py-1">
                              <p className="font-weight-bold text-uppercase">
                                b) Capacitación adicional requerida:
                              </p>
                            </Col>
                          </Row>
                        </Col>
                      </div>
                      <Table striped bordered hover>
                        <thead>
                          <tr>
                            <th className="text-muted">
                              <b>Curso/Seminario/Pasantia</b>
                            </th>
                            <th className="text-muted">
                              <b>Duracion en Horas</b>
                            </th>
                            <th className="text-muted">
                              <b>Deseable o indispensable</b>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {pdfDescriptor &&
                            pdfDescriptor.Conocimiento_y_Experiencia.capacitacion_adicion_requerida.map(
                              (fun) => (
                                <>
                                  <tr>
                                    <td>{fun.curso__nombre}</td>
                                    <td>{fun.curso__duracion}</td>
                                    <td>
                                      {fun.indispensable
                                        ? "Deseable"
                                        : "Indispensable"}
                                    </td>
                                  </tr>
                                </>
                              )
                            )}
                        </tbody>
                      </Table>
                    </Col>
                    <Col md="12" className="mt-3">
                      <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 py-2 text-muted d-flex flex-wrap justify-content-between align-items-center">
                        <Col md="12">
                          <Row className="justify-content-sm-end align-items-center flex-nowrap">
                            <Col className="px-0 py-1">
                              <p className="font-weight-bold text-uppercase">
                                c) Conocimientos Técnicos Especializados:
                              </p>
                            </Col>
                          </Row>
                        </Col>
                      </div>
                      <Table striped bordered hover>
                        <thead>
                          <tr>
                            <th className="text-muted">
                              <b>Conocimientos Técnicos</b>
                            </th>
                            <th className="text-muted">
                              <b>Descripción</b>
                            </th>
                            <th className="text-muted">
                              <b>Nivel de Profundidad</b>
                            </th>
                            <th className="text-muted">
                              <b>
                                Requerimiento de selección o de Capacitación
                              </b>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {pdfDescriptor &&
                            pdfDescriptor.Conocimiento_y_Experiencia.conocimientos_tecnicos.map(
                              (fun) => (
                                <>
                                  <tr>
                                    <td>{fun.nombre}</td>
                                    <td>{fun.descripcion}</td>
                                    <td>{fun.nivel_profundidad === 1 ? 'Básico' : fun.nivel_profundidad === 2 ? 'Intermedio' : 'Avanzado'}</td>
                                    <td>
                                      {fun.indispensable
                                        ? "Deseable"
                                        : "Indispensable"}
                                    </td>
                                  </tr>
                                </>
                              )
                            )}
                        </tbody>
                      </Table>
                    </Col>
                    <Col md="12" className="mt-3">
                      <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 py-2 text-muted d-flex flex-wrap justify-content-between align-items-center">
                        <Col md="12">
                          <Row className="justify-content-sm-end align-items-center flex-nowrap">
                            <Col className="px-0 py-1">
                              <p className="font-weight-bold text-uppercase">
                                d) Experiencia laboral requerida:
                              </p>
                            </Col>
                          </Row>
                        </Col>
                      </div>
                      <Table striped bordered hover>
                        <thead>
                          <tr>
                            <th className="text-muted">
                              <b>Dimensión Experiencia</b>
                            </th>
                            <th colSpan="2">
                              <b>Experiencia Instituciones</b>
                            </th>
                            <th colSpan="2">
                              <b>Experiencia en Cargos</b>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {pdfDescriptor &&
                            pdfDescriptor.experiencia_laboral_requerida.map(
                              (fun) => (
                                <>
                                  <tr>
                                    <td>
                                      {fun.tiempo}
                                      {" - "}
                                      {fun.tiempo_2}
                                    </td>
                                    <td>
                                      {fun.experiencia_tipo_institucion
                                        ? "Si"
                                        : "No"}
                                    </td>
                                    <td>
                                      {fun.experiencia_tipo_institucion_detalle}
                                    </td>
                                    <td>
                                      {fun.experiencia_tipo_cargo ? "Si" : "No"}
                                    </td>
                                    <td>
                                      {fun.experiencia_tipo_cargo_detalle}
                                    </td>
                                  </tr>
                                </>
                              )
                            )}
                        </tbody>
                      </Table>
                    </Col>
                  </div>
                </div>
                <div id="comentarioId">
                  <Col>
                    <p className="text-muted">
                      <b>{pdfDescriptor ? pdfDescriptor.fecha_actual : ""}</b>
                    </p>
                  </Col>
                  <Col md="12" className="mt-3 mb-3">
                    <Row className="d-flex flex-wrap justify-content-sm-between align-items-center">
                      <Form.Label
                        className="text-muted text-uppercase"
                        column
                        md="12"
                      >
                        <b>OBSERVACIONES:</b>
                        <br />
                      </Form.Label>
                      <Col>
                        <p className="text-muted">
                          <b>
                            Utilice este espacio en caso de querer señalar
                            alguna observación, sugerencia, comentario o
                            acuerdos de re editar o actualizar esta descripción.
                          </b>
                        </p>
                      </Col>
                      <Col md="12">
                        <div
                          className="px-2 py-1 rounded border border-muted"
                          style={{
                            minHeight: "200px",
                          }}
                        >
                          {overviews.informacion &&
                          overviews.informacion.data &&
                          overviews.informacion.data[0].comentario_evaluado
                            ? overviews.informacion.data[0].comentario_evaluado
                            : ""}
                        </div>
                      </Col>
                    </Row>
                  </Col>
                  <Col md="12" className="mt-3 mb-3">
                    <Row className="d-flex flex-wrap justify-content-sm-between align-items-center">
                      <Form.Label
                        className="text-muted text-uppercase"
                        column
                        md="12"
                      >
                        <b>OBSERVACIONES:</b>
                        <br />
                      </Form.Label>
                      <Col>
                        <p className="text-muted">
                          <b>
                            Fecha:{" "}
                            {pdfDescriptor
                              ? pdfDescriptor.fecha_actualizacion_descriptor
                              : ""}
                          </b>
                        </p>
                      </Col>
                    </Row>
                    <Row className="my-3 d-flex flex-wrap justify-content-sm-between align-items-center">
                      <Col
                        xl="4"
                        lg="4"
                        md="4"
                        sm="4"
                        xs="4"
                        className="text-muted mx-auto my-5 d-flex flex-wrap justify-content-sm-between align-items-center"
                      >
                        <Row className="my-3 d-flex flex-wrap justify-content-sm-between align-items-center">
                          <Col md="12">
                            <Col
                              className="d-flex flex-wrap justify-content-center align-items-center text-center"
                              md="12"
                            >
                              <p
                                className="text-uppercase"
                                style={{ minHeight: "39px" }}
                              >
                                <b>
                                  {pdfDescriptor && props.id_colab
                                    ? pdfDescriptor.colaborador
                                    : ""}
                                </b>
                              </p>
                            </Col>
                            <div className="px-2">
                              <hr
                                style={{
                                  borderColor: "black",
                                }}
                              />
                            </div>
                          </Col>
                          <Col md="12">
                            <Row className="d-flex flex-wrap justify-content-center align-items-center px-2">
                              <Col
                                className="d-flex flex-wrap justify-content-center align-items-center text-center"
                                md="12"
                              >
                                <p className="text-uppercase">
                                  <b>Ocupante del puesto</b>
                                </p>
                              </Col>
                              <Col
                                className="d-flex flex-wrap justify-content-center align-items-center text-center"
                                md="12"
                              >
                                <p className="text-uppercase">
                                  <b>
                                    {pdfDescriptor && props.id_colab
                                      ? pdfDescriptor.puesto_colaborador
                                      : ""}
                                  </b>
                                </p>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                      <Col
                        xl="4"
                        lg="4"
                        md="4"
                        sm="4"
                        xs="4"
                        className="text-muted mx-auto my-5 d-flex flex-wrap justify-content-sm-between align-items-center"
                      >
                        <Row className="my-3 d-flex flex-wrap justify-content-sm-between align-items-center">
                          <Col md="12">
                            <Col
                              className="d-flex flex-wrap justify-content-center align-items-center text-center"
                              md="12"
                            >
                              <p
                                className="text-uppercase"
                                style={{ minHeight: "39px" }}
                              >
                                <b>
                                  {pdfDescriptor && props.id_colab
                                    ? pdfDescriptor.nombre_jefe_inmediato
                                    : ""}
                                </b>
                              </p>
                            </Col>
                            <div className="px-2">
                              <hr
                                style={{
                                  borderColor: "black",
                                }}
                              />
                            </div>
                          </Col>
                          <Col md="12">
                            <Row className="d-flex flex-wrap justify-content-center align-items-center px-2">
                              <Col
                                className="d-flex flex-wrap justify-content-center align-items-center text-center"
                                md="12"
                              >
                                <p className="text-uppercase">
                                  <b>Jefe inmediato</b>
                                </p>
                              </Col>
                              <Col
                                className="d-flex flex-wrap justify-content-center align-items-center text-center"
                                md="12"
                              >
                                <p className="text-uppercase">
                                  <b>
                                    {pdfDescriptor && props.id_colab
                                      ? pdfDescriptor.puesto_jefe
                                      : ""}
                                  </b>
                                </p>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                      <Col
                        xl="4"
                        lg="4"
                        md="4"
                        sm="4"
                        xs="4"
                        className="text-muted mx-auto my-5 d-flex flex-wrap justify-content-sm-between align-items-center"
                      >
                        <Row className="my-3 d-flex flex-wrap justify-content-sm-between align-items-center">
                          <Col md="12">
                            <Col
                              className="d-flex flex-wrap justify-content-center align-items-center text-center"
                              md="12"
                            >
                              <p
                                className="text-uppercase"
                                style={{ minHeight: "39px" }}
                              >
                                <b>
                                  {pdfDescriptor && props.id_colab
                                    ? pdfDescriptor.descriptor_actualizado_por
                                    : ""}
                                </b>
                              </p>
                            </Col>
                            <div className="px-2">
                              <hr
                                style={{
                                  borderColor: "black",
                                }}
                              />
                            </div>
                          </Col>
                          <Col md="12">
                            <Row className="d-flex flex-wrap justify-content-center align-items-center px-2">
                              {/* <Col
                                className="mb-1 d-flex flex-wrap justify-content-center align-items-center"
                                md="12"
                              >
                                <p className="text-uppercase">
                                  <b>
                                    {overviews &&
                                    overviews.informacion &&
                                    overviews.informacion.data &&
                                    overviews.informacion.data[0].evaluadores
                                      ? overviews.informacion.data[0]
                                          .tipo_evaluacion === "0°"
                                        ? overviews.informacion.data[0]
                                            .jefe_evaluado_nombre
                                        : overviews.informacion.data[0]
                                            .evaluadores[0].Evaluador
                                      : null}
                                  </b>
                                </p>
                              </Col> */}
                              <Col
                                className="d-flex flex-wrap justify-content-center align-items-center text-center"
                                md="12"
                              >
                                <p className="text-uppercase">
                                  <b>Recursos Humanos</b>
                                </p>
                              </Col>
                              <Col
                                className="d-flex flex-wrap justify-content-center align-items-center text-center"
                                md="12"
                              >
                                <p className="text-uppercase">
                                  <b>
                                    {pdfDescriptor && props.id_colab
                                      ? pdfDescriptor.puesto_actualizado_por
                                      : ""}
                                  </b>
                                </p>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                </div>
              </div>
            </>
          )}
        </Container>
      </div>
    </>
  );
};

export default DocumentoDescriptorPDFComponent;
